/* eslint-disable */
import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  Box,
  Collapse,
  Flex,
  HStack,
  Icon,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
import { useAuth } from "contexts/AuthContext";
import { PERMISSIONS, userHasPermission } from "constants/permissions";

function routeSidebarLabel(route, user) {
  if (route.path === "/finance" && user) {
    const isDoctor = user.role === "doctor" || user.isDoctor;
    if (
      isDoctor &&
      userHasPermission(user, PERMISSIONS.PAYROLL) &&
      !userHasPermission(user, PERMISSIONS.EXPENSES) &&
      !userHasPermission(user, PERMISSIONS.DASHBOARD_FINANCE)
    ) {
      return "Мои финансы";
    }
  }
  return route.name;
}

function isSidebarSectionActive(location, subRoute) {
  if (!subRoute?.sidebarSection) return false;
  const params = new URLSearchParams(location.search);
  return (
    location.pathname.includes(subRoute.path) &&
    params.get("section") === subRoute.sidebarSection
  );
}

function CollapseSidebarItem({
  route,
  user,
  activeColor,
  inactiveColor,
  activeIcon,
  textColor,
  brandColor,
}) {
  const location = useLocation();
  const isParentActive = location.pathname.includes(route.path);
  const isChildActive = (route.items || []).some((item) =>
    isSidebarSectionActive(location, item)
  );
  const [open, setOpen] = useState(isParentActive || isChildActive);

  useEffect(() => {
    if (isParentActive || isChildActive) setOpen(true);
  }, [isParentActive, isChildActive]);

  return (
    <Box>
      <Flex
        align="center"
        py="5px"
        ps="10px"
        cursor="pointer"
        onClick={() => setOpen((value) => !value)}
        role="button"
        aria-expanded={open}
      >
        <Flex w="100%" alignItems="center" justifyContent="center">
          <Box color={isChildActive ? activeIcon : textColor} me="18px">
            {route.icon}
          </Box>
          <Text
            me="auto"
            color={isChildActive ? activeColor : textColor}
            fontWeight={isChildActive ? "bold" : "normal"}
          >
            {routeSidebarLabel(route, user)}
          </Text>
          <Icon
            as={open ? MdExpandLess : MdExpandMore}
            color={textColor}
            boxSize={5}
            me="12px"
          />
        </Flex>
        <Box
          h="36px"
          w="4px"
          bg={isChildActive ? brandColor : "transparent"}
          borderRadius="5px"
        />
      </Flex>
      <Collapse in={open} animateOpacity>
        <Box pb={1}>
          {(route.items || []).map((subRoute, subIndex) => {
            const active = isSidebarSectionActive(location, subRoute);
            const to = subRoute.sidebarSection
              ? {
                  pathname: `${subRoute.layout}${subRoute.path}`,
                  search: `?section=${subRoute.sidebarSection}`,
                }
              : `${subRoute.layout}${subRoute.path}`;

            return (
              <NavLink key={`${subRoute.name}-${subIndex}`} to={to}>
                <HStack spacing="22px" py="8px" ps="42px" pe="10px">
                  <Text
                    me="auto"
                    fontSize="sm"
                    color={active ? activeColor : inactiveColor}
                    fontWeight={active ? "bold" : "normal"}
                  >
                    {subRoute.name}
                  </Text>
                  <Box
                    h="28px"
                    w="4px"
                    bg={active ? brandColor : "transparent"}
                    borderRadius="5px"
                  />
                </HStack>
              </NavLink>
            );
          })}
        </Box>
      </Collapse>
    </Box>
  );
}

export function SidebarLinks(props) {
  const { user } = useAuth();
  const location = useLocation();
  let activeColor = useColorModeValue("gray.700", "white");
  let inactiveColor = useColorModeValue(
    "secondaryGray.600",
    "secondaryGray.600"
  );
  let activeIcon = useColorModeValue("brand.500", "white");
  let textColor = useColorModeValue("secondaryGray.500", "white");
  let brandColor = useColorModeValue("brand.500", "brand.400");
  let categoryColor = useColorModeValue("secondaryGray.500", "secondaryGray.400");

  const { routes } = props;

  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  const createLinks = (routeList) => {
    return routeList.map((route, index) => {
      if (route.category) {
        return (
          <React.Fragment key={`category-${index}`}>
            <Text
              fontSize={"xs"}
              textTransform="uppercase"
              letterSpacing="wider"
              color={categoryColor}
              fontWeight="700"
              mx="auto"
              ps={{
                sm: "10px",
                xl: "16px",
              }}
              pt="18px"
              pb="8px"
            >
              {route.name}
            </Text>
            {createLinks(route.items)}
          </React.Fragment>
        );
      }

      if (route.collapse && Array.isArray(route.items) && route.items.length > 0) {
        return (
          <CollapseSidebarItem
            key={`collapse-${route.path}-${index}`}
            route={route}
            user={user}
            activeColor={activeColor}
            inactiveColor={inactiveColor}
            activeIcon={activeIcon}
            textColor={textColor}
            brandColor={brandColor}
          />
        );
      }

      if (route.layout === "/admin") {
        if (route.hideInSidebar) return null;
        return (
          <NavLink key={index} to={route.layout + route.path}>
            {route.icon ? (
              <Box>
                <HStack
                  spacing={
                    activeRoute(route.path.toLowerCase()) ? "22px" : "26px"
                  }
                  py="5px"
                  ps="10px"
                >
                  <Flex w="100%" alignItems="center" justifyContent="center">
                    <Box
                      color={
                        activeRoute(route.path.toLowerCase())
                          ? activeIcon
                          : textColor
                      }
                      me="18px"
                    >
                      {route.icon}
                    </Box>
                    <Text
                      me="auto"
                      color={
                        activeRoute(route.path.toLowerCase())
                          ? activeColor
                          : textColor
                      }
                      fontWeight={
                        activeRoute(route.path.toLowerCase())
                          ? "bold"
                          : "normal"
                      }
                    >
                      {routeSidebarLabel(route, user)}
                    </Text>
                  </Flex>
                  <Box
                    h="36px"
                    w="4px"
                    bg={
                      activeRoute(route.path.toLowerCase())
                        ? brandColor
                        : "transparent"
                    }
                    borderRadius="5px"
                  />
                </HStack>
              </Box>
            ) : (
              <Box>
                <HStack
                  spacing={
                    activeRoute(route.path.toLowerCase()) ? "22px" : "26px"
                  }
                  py="5px"
                  ps="10px"
                >
                  <Text
                    me="auto"
                    color={
                      activeRoute(route.path.toLowerCase())
                        ? activeColor
                        : inactiveColor
                    }
                    fontWeight={
                      activeRoute(route.path.toLowerCase()) ? "bold" : "normal"
                    }
                  >
                    {route.name}
                  </Text>
                  <Box h="36px" w="4px" bg="brand.400" borderRadius="5px" />
                </HStack>
              </Box>
            )}
          </NavLink>
        );
      }

      return null;
    });
  };

  return createLinks(routes);
}

export default SidebarLinks;
